import * as getters from "../../baseQuestion/text/store/getters";
import * as mutations from "../../baseQuestion/text/store/mutations";
import * as actions from "../../baseQuestion/text/store/actions";
import { state as base_state } from "../../baseQuestion/text/store/state";

function state() {
	return Object.assign(
		{
			options: [
				{
					value: "Y",
					text: "Yes"
				},
				{
					value: "N",
					text: "No"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
